import {
  getFinancialArrangments as getFinancialArrangmentsApi,
  updateFinancialArrangments as updateFinancialArrangmentsApi,
  createClientSecrete as createClientSecreteApi,
  validateStripeAccount as validateStripeAccountApi,
  getSavedPaymentMethods as getSavedPaymentMethodsApi,
  getMemberships as getMembershipsApi,
  createMembership as createMembershipApi,
  cancelMembership as cancelMembershipApi,
  changeMembershipPlan as changeMembershipPlanApi,
  resumeMembership as resumeMembershipApi,
  getMembershipRecovery as getMembershipRecoveryApi
} from './api'

let getFinancialArrangments = (params) => dispatch => {
  return getFinancialArrangmentsApi(params)
}

let updateFinancialArrangments = (data, params = {}) => dispatch => {
  return updateFinancialArrangmentsApi(data, params)
}

let createClientSecrete = (data) => dispatch => {
  return createClientSecreteApi(data)
}

let validateStripeAccount = (data) => dispatch => {
  return validateStripeAccountApi(data)
}

let getSavedPaymentMethods = (params = {}) => dispatch => {
  return getSavedPaymentMethodsApi(params)
}

let getMemberships = (params = {}) => dispatch => {
  return getMembershipsApi(params)
}

let createMembership = (data) => dispatch => {
  return createMembershipApi(data)
}

let cancelMembership = (id, data = {}) => dispatch => {
  return cancelMembershipApi(id, data)
}

let changeMembershipPlan = (id, data) => dispatch => {
  return changeMembershipPlanApi(id, data)
}

let resumeMembership = (id) => dispatch => {
  return resumeMembershipApi(id)
}

let getMembershipRecovery = (id) => dispatch => {
  return getMembershipRecoveryApi(id)
}

export {
  getFinancialArrangments,
  updateFinancialArrangments,
  createClientSecrete,
  validateStripeAccount,
  getSavedPaymentMethods,
  getMemberships,
  createMembership,
  cancelMembership,
  changeMembershipPlan,
  resumeMembership,
  getMembershipRecovery
}
